import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Modal,
  Row,
  Select,
  Table,
  Tooltip,
  Tree,
  Image,
  message,
  Drawer,
  Spin
} from "antd";
import React, { Component } from "react";
import CompanyAutocomplete from "./CompanyAutocomplete";
import { addMinutes, format } from "date-fns";
import dayjs from "dayjs";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import { observer } from "mobx-react";
import VideoMonitoringStore from "../store/VideoMonitoringStore";
import HistoryTrackingStore from "../store/HistoryTrackingStore";
import { CheckLg, PauseCircle, PlayCircle } from "react-bootstrap-icons";
import FlvPlayer from "./Flvplayer";
import HLSPlayer from "./HlsPlayer";
import { tr } from "date-fns/locale";
import singleImg from "../assets/images/single.png";
import doubleImg from "../assets/images/double.png";
import fourImg from "../assets/images/four.png";
import nineImg from "../assets/images/nine.png";
import { LAYOUTS } from './Layout';
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  ResponsiveContainer,
  ReferenceArea
} from "recharts";
import "leaflet-arrowheads";
import "leaflet/dist/leaflet.css";
import "@elfalem/leaflet-curve";
import { Icon } from "leaflet";
import { MapContainer, TileLayer } from "react-leaflet";
import L from "leaflet";
import ReactLeafletGoogleLayer from "react-leaflet-google-layer";
import AdditionalContentInMap from "./AdditionalContentInMap";
import config from "../config";
import VehicleOtherInfoStore from "../store/VehicleOtherInfoStore";
import { ArrowLeftOutlined, AudioOutlined, LoadingOutlined } from '@ant-design/icons';
import axios from "axios";
import Hls from 'hls.js';
const dummyPlaybackData = [
  { channelNo: 1, startTime: "", time: 407, duration: 21, videoUrl: "..." }, // 01:00–01:45
  { channelNo: 1, startTime: "", time: 389, duration: 17, videoUrl: "..." }, // 01:00–01:45

];
const SERVER_PORT = 22107
const SERVER_HOST = "130.110.114.14"
const filledData = [...dummyPlaybackData];

// Add dummy points for empty channels (time = 0 or any value outside visible range)
for (let ch = 1; ch <= 8; ch++) {
  if (!filledData.find(d => d.channelNo === ch)) {
    filledData.push({ time: -1, channelNo: ch, videoUrl: null, hidden: true });
  }
}

filledData.sort((a, b) => {
  if (a.channelNo === b.channelNo) {
    return a.time - b.time;
  }
  return a.channelNo - b.channelNo;
});

filledData.forEach(p => {
  p.fillOpacity = p.hidden ? 0 : 1;
});

const minuteTicks = Array.from({ length: 25 }, (_, i) => i * 60);
// console.log("minuteTicks", minuteTicks)

const timeArray = [];
const downloadTimeArray = [];

const startTime = new Date(2000, 0, 1, 0, 0); // 12:00 AM
const endTime = new Date(2000, 0, 1, 23, 30); // 11:45 P

for (let time = startTime; time <= endTime; time = addMinutes(time, 30)) {
  const formattedTime = format(time, "HH:mm:ss");
  var ob = {
    formattedTime: formattedTime,
    time: time,
  };
  timeArray.push(ob);
}

for (let time = startTime; time <= endTime; time = addMinutes(time, 1)) {
  const formattedTime = format(time, "HH:mm:ss");
  var ob = {
    formattedTime: formattedTime,
    time: time,
  };
  downloadTimeArray.push(ob);
}

const LAYOUT_ICONS = [
  { id: "ONE", img: singleImg, title: "1 Channel" },
  { id: "TWO", img: doubleImg, title: "2 Channels" },
  { id: "FOUR", img: fourImg, title: "4 Channels" },
  { id: "NINE", img: nineImg, title: "9 Channels" }
];
const vdostatusStyle = {
  width: "100%",
  height: "200px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontWeight: "bold",
  textAlign: "center",
  fontSize: "16px",
};
const LayoutRenderer = ({ layout, channels, videoStatus }) => {
  // console.log("LayoutRenderer", layout, channels, videoStatus);
  // console.log(videoStatus[0])
  const isSingle = (channels.length === 1 && layout.id === "one");

  let hf = 130;
  if (channels.length === 1 || channels.length === 2) {
    hf = 510;
  } else if (channels.length > 2 && channels.length <= 4) {
    hf = 240;
  } else if (channels.length > 4) {
    hf = 140;
  }

  let minHeight = 250;
  if (channels.length > 0) {
    minHeight = 100;
  }

  // console.log("Rendering layout:", layout, "with channels:", channels, " isSingle:", isSingle);
  return (
    <div style={gridStyle(layout.columns)}>
      {layout.cells.map((cell, index) => {
        const channel = channels[index];
        // console.log("channel", cell, index);
        // console.log(videoStatus[index]);

        return (
          <div
            key={index}
            style={{
              gridColumn: `span ${cell.colSpan}`,
              gridRow: `span ${cell.rowSpan}`,
              background: "#fff",
              borderRadius: 10,
              border: "1px solid #e5e7eb",
              overflow: "hidden",
              minHeight: minHeight,
            }}
          >
            {channel ? (
              <>
                {/* Channel Title */}
                <div style={{ padding: 8, fontWeight: 600 }}>
                  {channel.title}
                </div>

                {/* Video   510,240,130 */}
                <div style={{ height: hf }}>
                  {channel.mdvr === "H-Protocol" ? (

                    // <HLSPlayer src={channel.src} isSingle={isSingle} heightFactor={hf} />

                    videoStatus[index].chkvdoStatus === "initiated" ? (
                      <div className="streamStatus" style={vdostatusStyle}>Stream Initiated...</div>
                    ) : videoStatus[index].chkvdoStatus === "pending" ? (
                      <div className="streamStatus" style={vdostatusStyle}>Pending / Waiting For Stream...</div>
                    ) : videoStatus[index].chkvdoStatus === "started" ? (
                      <HLSPlayer src={channel.src} interval={2000} isSingle={isSingle} heightFactor={hf} />
                    ) : videoStatus[index].chkvdoStatus === "not_available" ? (
                      <div className="streamStatusError" style={vdostatusStyle}>Stream Not Available</div>
                    ) : null



                  ) : channel.mdvr === "JT1078" ? (
                    <FlvPlayer url={channel.src} heightFactor={hf} />
                  ) : (
                    <iframe
                      src={channel.src}
                      width="100%"
                      height="100%"
                      frameBorder="0"
                      allow="fullscreen"
                    />
                  )}
                </div>
              </>
            ) : (
              <EmptySlot />
            )}
          </div>
        );
      })}
    </div>
  );
};

const DynamicGridRenderer = ({ channels, onhandleDownloadChannel }) => {
  const count = channels.length;

  const getWidth = () => {
    if (count === 1) return "23%";
    if (count === 2) return "50%";
    if (count === 3) return "30.3333%";
    if (count === 4) return "23%";
    return "25%"; // fallback
  };

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        height: "100%",
        justifyContent: "flex-start", //count === 1 ? "center" : "flex-start",
        gap: 10,
        padding: 0,
        boxSizing: "border-box",
      }}
    >
      {channels.map((channel, index) => (
        <div
          key={index}
          style={{
            width: getWidth(),
            height: "100%",
            background: "#fff",
            borderRadius: 10,
            border: "1px solid #e5e7eb",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Channel title */}
          <div style={{
            padding: 8, fontWeight: 600, justifyContent: "space-between", display: "flex",
            alignItems: "center"
          }}>
            {channel.title}
            <img
              src={require("../assets/images/download.png")}
              alt="Download"
              style={{
                width: 20,
                height: 20,
                cursor: "pointer",
              }}
              onClick={() => onhandleDownloadChannel(channel)}
              title="Download"
            />
          </div>

          {/* Video area – fills remaining height */}
          <div style={{ flex: 1 }}>
            {channel.mdvr === "H-Protocol" ? (
              <HLSPlayer src={channel.src} isSingle={true} heightFactor={172} />
            ) : channel.mdvr === "JT1078" ? (
              <FlvPlayer url={channel.src} heightFactor={172} />

            ) : (
              <iframe
                src={channel.src}
                width="100%"
                style={{ objectFit: 'fill' }}
                height="100%"
                frameBorder="0"
                allow="fullscreen"
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

const EmptySlot = () => (
  <div
    style={{
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#9ca3af",
      fontSize: 14,
    }}
  >
    No Channel Selected
  </div>
);

const gridStyle = (columns) => ({
  display: "grid",
  gridTemplateColumns: `repeat(${columns}, 1fr)`,
  gap: "16px",
  width: "100%",
});

class VideoMonitoring extends Component {
  constructor(props, context) {
    super(props);
    this.formRef = React.createRef();
    this.downloadformRef = React.createRef();
    this.chartRef = React.createRef();
    this.mapRef = React.createRef();
    this.polyline2 = null;
    this.marker2 = [];
    this.audioRef = React.createRef();
    this.hlsInstance = null;
    this.state = {
      videoUrlArray: [],
      companyId: "",
      iframeSrcs: [],
      openVideoModal: false,
      selectedIframe: null,
      showPlaybackTable: false,
      showHowenPlaybackTable: false,
      showDownloadedVideoList: false,
      isPause: true,
      treeData: [],
      playbackVideoUrl: "",
      howenplaybackVideoUrl: "",
      showVideoWindow: false,
      showHowenVideoWindow: false,
      activeRow: null,
      channelId: 0,
      vehicleId: "",
      selectedData: [],
      showVideo: "",
      openCard: true,
      hiddenIframeKeys: [],
      mdvr: "",
      showDownloadbtn: false,
      fromDate: '',
      toDate: '',
      showPlaybackPanel: false,
      videoGroups: {},
      fullscreenCompanyId: null,
      selectedLayoutId: "four",
      selectedLayoutByCompany: {},
      showDefaultImage: true,
      selectedChannels: [],
      downloadChannels: [],
      multiPlaybackUrls: [],
      showPlaybackvideoPanel: false,
      isSelecting: false,
      selectionStart: null,
      selectionEnd: null,
      focusChartForDownload: false,
      showDownloadPopup: false,
      downloadStartTimeFormatted: "12:00 AM",
      downloadEndTimeFormatted: "12:00 AM",
      filledData: [],
      checkedKeys: [],
      playbackView: "CHART",
      selectedvehicleName: "",
      loadingData: false,
      videoDownloadId: 0,
      openRecordPopup: false,
      isRecording: false,
      audioURL: null,
      recordError: null,
      isUploading: false,
      uploadSuccess: false,
      recordImei: null,
      streamError: null,
      sessionNo: null
    };
    this.plotPolyLine = [];
    this.polylines = {};
    this.currentPlayingRecord = {};
    this.tripPolyline = null;
    this.circleMarkers = [];
    this.circleMarkersByRecord = {};
    this.audioStream = null;
    this.mapOptions = [
      {
        label: "Google",
        value: "google",
      },
      {
        label: "Openstreet",
        value: "openstreet",
      },
    ];
    this.removeMarkerPoints = [];
    this.historyTrackingStore = new HistoryTrackingStore(this);
    this.videoMonitoringStore = new VideoMonitoringStore(this);
    this.vehicleOtherInfoStore = new VehicleOtherInfoStore();

    this.columns = [
      {
        title: context.translate("_CHANNEL_"),
        dataIndex: this.state.mdvr === "H-Protocol" ? "channelNo" : "logicalChannelNumber",
        width: "12%",
        render: (text, record) => {
          return this.state.mdvr === "H-Protocol"
            ? record.channelNo
            : record.logicalChannelNumber ?? "";
        }
      },
      {
        title: context.translate("_STARTTIME_"),
        dataIndex: "startTime",
        width: "18%",
      },
      {
        title: context.translate("_END_TIME_"),
        dataIndex: "endTime",
        width: "18%",
      },
      {
        title: context.translate("_PLAY_"),
        width: "10%",
        render: (text, record) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            {this.state.activeRow === record.startTime ? (
              <Tooltip title={"Pause"} color="green">
                <PauseCircle
                  style={{ fontSize: "20px", cursor: "pointer" }}
                  onClick={() => {
                    this.setState({
                      activeRow: null,
                      showVideoWindow: false,
                      showHowenVideoWindow: false,
                      playbackVideoUrl: "",
                      howenplaybackVideoUrl: ""
                    });
                    if (this.state.mdvr === "JT1078") {
                      this.videoMonitoringStore.stopBsjVideo(record);
                    }
                  }}
                />
              </Tooltip>
            ) : (
              <Tooltip title={"Play"} color="green">
                {" "}
                <PlayCircle
                  style={{ fontSize: "20px", cursor: "pointer" }}
                  onClick={async () => {
                    if (this.state.mdvr === "JT1078") {
                      if (this.state.channelId === record.logicalChannelNumber) {
                        Modal.warning({
                          title: this.context.translate(
                            "_FLEET_DASHBORD_SHOWGEO_REMOVEALERT_"
                          ),
                          content: this.context.translate(
                            "Live streaming is currently active on this channel, so playback of recorded videos is unavailable."
                          ),
                        });
                      } else {
                        this.handlePlaybackVideo(record);
                        this.setState({
                          activeRow: record.startTime,
                          showVideoWindow: true,
                        });
                      }
                    } else {
                      //this.handleHowenPlaybackVideo(record);
                      await this.setState({
                        selectedChannels: [record.channelNo]
                      });
                      this.handlePlaybackPointClick(record);
                    }

                  }}
                />
              </Tooltip>
            )}
            {/* <Tooltip title={"Download"} color="green">
              <DownloadOutlined
                style={{
                  fontSize: "20px",
                  paddingInlineStart: "7px",
                  cursor: "pointer",
                }}
              />
            </Tooltip> */}
          </div>
        ),
      },
      ...(!this.state.showDownloadedVideoList
        ? [{
          title: context.translate("Download"),
          width: "15%",
          align: "center",
          render: (text, record) => (
            <>
              {Number(record.downloadStatus) === 1 ? (
                <Tooltip title={"Download"} color="black">
                  <img
                    src={require("../assets/images/download.png")}
                    alt="Download"
                    style={{ width: 23, height: 23, cursor: "pointer" }}
                    onClick={async () => {
                      await this.setState({ downloadChannels: [record.channelNo], videoDownloadId: record.Id });
                      //await this.setState({ downloadChannels: [record.channelNo] })
                      this.startDownload(record);
                    }}
                  />
                </Tooltip>
              ) : Number(record.downloadStatus) === 2 ? (
                <Tooltip title={"Processing"} color="black">
                  <img
                    src={require("../assets/images/data-processing.png")}
                    alt="Processing"
                    style={{ width: 23, height: 23, cursor: "not-allowed" }}
                  />
                </Tooltip>
              ) : Number(record.downloadStatus) === 3 ? (
                <Tooltip title={"Downloaded"} color="black">
                  <img
                    src={require("../assets/images/success.png")}
                    alt="Downloaded"
                    style={{ width: 23, height: 23, cursor: "not-allowed" }}
                  />
                </Tooltip>
              ) : null}


            </>
          ),
        }]
        : []),
    ];


  }



  handleLayoutChange = (companyId, layoutId) => {
    this.setState(prev => ({
      selectedLayoutByCompany: {
        ...prev.selectedLayoutByCompany,
        [companyId]: layoutId
      }
    }));
  };

  getTimeFromMouse = (e, xAxis) => {
    const { left, width } = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - left;

    const ratio = x / width;
    const minutes = Math.round(ratio * 1440);

    return Math.max(0, Math.min(1440, minutes));
  };

  formatTime = (minutes) => {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  };

  handleDownloadChannel = async (channel) => {
    // console.log('Starting Download.........', channel);
    let channelsarray = [channel.channelId];
    await this.setState({ downloadChannels: channelsarray });
    // console.log('channel no..........', await this.state.downloadChannels);
    this.startDownload(channel);
  }

  startDownload = async (videoMetaData) => {
    // console.log('download channels....', this.state.downloadChannels);
    // console.log('videometadata..........', videoMetaData);
    // console.log('start time ', this.state.downloadStartTimeFormatted);
    // console.log('end time ...', this.state.downloadEndTimeFormatted);

    const values = this.formRef.current.getFieldsValue();
    const fromDate = dayjs(values.fromDate).format("YYYY-MM-DD");

    let startTime = fromDate + " " + this.convertMinutesTo24Hour(this.state.selectionStart);
    let endTime = fromDate + " " + this.convertMinutesTo24Hour(this.state.selectionEnd);

    if (videoMetaData?.startTime) {
      // console.log('Nooooooooooooooooooooooo', videoMetaData);
      startTime = videoMetaData.startTime;
      endTime = videoMetaData.endTime
    }


    try {
      const promises = this.state.downloadChannels.map(async channelNo => {

        const data = {
          companyId: this.state.companyId,
          channelId: channelNo,
          vehicleId: this.state.vehicleId,
          starttime: startTime,
          endTime: endTime,
          isDownload: 1,
          Id: this.state.videoDownloadId
        };

        // console.log('downloading Data for .....................', data);
        const videoData = await this.videoMonitoringStore.gethowenPlaybackVideoData(
          data
        );

        if (videoData) {
          data.url = videoData.url;
          const res = await this.videoMonitoringStore.downloadHowenVideo(data);
          if (res.success) {
            message.success(res.message);
          }
        }

        return {
          message: 'all data downloaded'
        };
      });

      const responseData = await Promise.all(promises);


      this.setState({
        showDownloadPopup: false, downloadChannels: [],
        downloadStartTimeFormatted: null,
        downloadEndTimeFormatted: null,
        selectionStart: null,
        selectionEnd: null
      })

    } catch (error) {
      console.error("Playback fetch failed", error);
      this.setState({
        showDownloadPopup: false, downloadChannels: [],
        downloadStartTimeFormatted: null,
        downloadEndTimeFormatted: null,
        selectionStart: null,
        selectionEnd: null
      })
    }

  }

  handlePlaybackPointClick = async (point) => {

    this.setState({ showPlaybackvideoPanel: false });

    try {


      if (this.state.selectedChannels.length > 0) {
        const promises = this.state.selectedChannels.map(async channelNo => {
          const data = {
            companyId: this.state.companyId,
            channelId: channelNo,
            vehicleId: this.state.vehicleId,
            starttime: point.startTime,
            beginTime: point.startTime,
            endTime: point.endTime,
            mdvr: this.state.mdvr,
            full_imei: point.terminalPhone ? point.terminalPhone : "",
            streamType: point.streamType ? point.streamType : "",
            memoryType: point.memoryType ? point.memoryType : "",
            logicalChannelNumber: channelNo,
            terminalPhone: point.terminalPhone ? point.terminalPhone : "",
          };

          let videoData;

          if (this.state.mdvr === 'JT1078') {

            await this.videoMonitoringStore.stopBsjVideo(data);
            videoData =
              await this.videoMonitoringStore.getPlaybackVideoData(data);

          } else {
            videoData =
              await this.videoMonitoringStore.gethowenPlaybackVideoData(data);
          }

          return {
            src: videoData?.url,
            title: 'Channel ' + channelNo,
            mdvr: this.state.mdvr,
            startTime: point.startTime,
            endTime: point.endTime,
            companyId: this.state.companyId,
            channelId: channelNo,
            vehicleId: this.state.vehicleId
          };
        });

        const multiPlaybackUrls = await Promise.all(promises);
        // console.log('multiPlaybackUrls...........', multiPlaybackUrls);
        await this.setState({ multiPlaybackUrls, showPlaybackvideoPanel: true });
      } else {
        message.error(this.context.translate("_SELECT_CHANNEL_ERROR_"));
      }


    } catch (error) {
      console.error("Playback fetch failed", error);
    }
  };




  toggleSelectedChannel = (ch) => {
    this.setState(prev => {
      const selected = prev.selectedChannels.includes(ch)
        ? prev.selectedChannels.filter(c => c !== ch)
        : [...prev.selectedChannels, ch];
      return { selectedChannels: selected };
    });
  };



  handlePlaybackVideo = async (record) => {
    const data = {
      channelId: record.logicalChannelNumber,
      vehicleId: this.state.vehicleId,
      full_imei: record.terminalPhone,
      streamType: record.streamType,
      memoryType: record.memoryType,
      beginTime: record.startTime,
      endTime: record.endTime,
    };
    const videoData = await this.videoMonitoringStore.getPlaybackVideoData(
      data
    );

    this.setState({ playbackVideoUrl: videoData.url });
  };
  handleHowenPlaybackVideo = async (record) => {
    const data = {
      companyId: this.state.companyId,
      channelId: record.channelNo,
      vehicleId: this.state.vehicleId,
      starttime: record.startTime,
      endTime: record.endTime,
    };
    const videoData = await this.videoMonitoringStore.gethowenPlaybackVideoData(
      data
    );

    this.setState({ howenplaybackVideoUrl: videoData.url });
  };


  onSubmit = async (obj) => {
    const filteredData = this.state.treeData?.filter(
      (item) => item.vehicleId === this.state.vehicleId
    );

    const MDVR = filteredData[0]?.MDVR;
    this.setState({ showVideo: MDVR, mdvr: MDVR, openCard: false, showPlaybackPanel: false, showDefaultImage: false, checkedKeys: [] });

    var fromDate = dayjs(obj.fromDate).format("YYYY-MM-DD");
    var toDate = fromDate;
    var fromTime = obj.fromTime;
    var toTime = obj.toTime; //dayjs().format("HH:mm:ss");
    var data = {
      channelId: [1, 2, 3, 4, 5, 6, 7, 8],
      companyId: this.state.companyId,
      vehicleId: obj.vehicleId,
      starttime: fromDate + " " + fromTime,
      endtime: toDate + " " + toTime,
    };

    const playbackData = {
      companyId: this.state.companyId,
      vehicleId: obj.vehicleId,
      channelId: [1, 2, 3, 4, 5, 6, 7, 8],
      starttime: fromDate + " " + fromTime,
      endtime: toDate + " " + toTime,
      imei: filteredData[0]?.full_imei,
    };

    this.setState({
      fromDate: fromDate + " " + fromTime,
      toDate: toDate + " " + toTime,
      loadingData: true,
    })

    // console.log('playbackData...........', MDVR);

    if (MDVR === "JT1078") {

      await this.videoMonitoringStore.getPlayBackVideoNew(playbackData);
      let dataReceived = false;
      const bsjData = await this.videoMonitoringStore.getPlaybackData(playbackData);

      dataReceived = true;
      // console.log('Data received .............................................', bsjData);

      let filledDataCopy = bsjData.data.data;


      // Add dummy points for empty channels (time = 0 or any value outside visible range)
      for (let ch = 1; ch <= 8; ch++) {
        if (!filledDataCopy.find(d => d.channelNo === ch)) {
          filledDataCopy.push({ time: -1, channelNo: ch, videoUrl: null, hidden: true });
        }
      }

      filledDataCopy.sort((a, b) => {
        if (a.channelNo === b.channelNo) {
          return a.time - b.time;
        }
        return a.channelNo - b.channelNo;
      });

      filledDataCopy.forEach(p => {
        p.fillOpacity = p.hidden ? 0 : 1;
      });
      await this.setState({ filledData: filledDataCopy });
      // console.log('new data...................', this.state.filledData);

      //await this.setState({ showPlaybackTable: true, showHowenPlaybackTable: false, showDownloadedVideoList: false, showPlaybackvideoPanel: false });
      await this.setState({ showHowenPlaybackTable: true, showPlaybackTable: false, showDownloadedVideoList: false });
    } else if (MDVR === "H-Protocol") {
      await this.videoMonitoringStore.fileRequestHowen(playbackData);
      await this.setState({ showHowenPlaybackTable: true, showPlaybackTable: false, showDownloadedVideoList: false });
      let attempt = 0;
      let dataReceived = false;

      while (attempt < 5 && !dataReceived) {
        const data = await this.videoMonitoringStore.gethowenPlaybackData(playbackData);

        if (data?.data?.data.length > 0) {
          dataReceived = true;
          // console.log('Data received .............................................', data);

          let filledDataCopy = data.data.data;


          // Add dummy points for empty channels (time = 0 or any value outside visible range)
          for (let ch = 1; ch <= 8; ch++) {
            if (!filledDataCopy.find(d => d.channelNo === ch)) {
              filledDataCopy.push({ time: -1, channelNo: ch, videoUrl: null, hidden: true });
            }
          }

          filledDataCopy.sort((a, b) => {
            if (a.channelNo === b.channelNo) {
              return a.time - b.time;
            }
            return a.channelNo - b.channelNo;
          });

          filledDataCopy.forEach(p => {
            p.fillOpacity = p.hidden ? 0 : 1;
          });
          await this.setState({ filledData: filledDataCopy });
          // console.log('new data...................', this.state.filledData);
          break; // exit loop if data is received
        } else {
          await this.setState({ filledData: [] });
        }


        attempt++;
        if (attempt < 5) {
          await new Promise(resolve => setTimeout(resolve, 5000)); // wait 5 sec between attempts
        }
      }

      if (!dataReceived) {
        Modal.warning({
          title: this.context.translate(
            "_FLEET_ALERT_"
          ),
          content: this.context.translate(
            'No data available'
          ),
        })
      }
      this.setState({ loadData: 1 })

    } else {

      const resp = await this.videoMonitoringStore.getPlayBackVideoNew(data);

      const videoUrls = [
        resp?.url1,
        resp?.url2,
        resp?.url3,
        resp?.url4,
        resp?.url5,
        resp?.url6,
        resp?.url7,
        resp?.url8,
      ];
      await this.setState({ videoUrlArray: videoUrls });

    }
    this.setState({ loadingData: false });
    this.getPolylineData();
  };

  handleChange = async (v) => {
    await this.setState({ companyId: v.value });
    // console.log("Selected company:", v);
    const data = await this.videoMonitoringStore.getDevices({
      companyId: v.value,
    });

    await this.setState({
      treeData: data,
      showPlaybackTable: false,
      showHowenPlaybackTable: false,
      showDownloadedVideoList: false,
      showPlaybackvideoPanel: false,
      iframeSrcs: [],
    });
    await this.setState({ update: 1 });
    await this.clearMap();
  };

  async componentDidMount() {

    document.addEventListener("fullscreenchange", () => {
      if (!document.fullscreenElement) {
        this.setState({ fullscreenCompanyId: null });
      }
    });

    document.addEventListener("keydown", this.handleEsc);

    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      const data = await this.videoMonitoringStore.getDevices({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.setState({ treeData: data, update: 1 });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleEsc);
    if (this.uploadTimeout) clearTimeout(this.uploadTimeout);
    if (this.uploadInterval) clearInterval(this.uploadInterval);
    if (this.playAudioTimeout) clearTimeout(this.playAudioTimeout);
    if (this.startRecordingTimeout) clearTimeout(this.startRecordingTimeout); // add this

  }

  componentDidUpdate(prevProps, prevState) {


    // Card just opened
    if (!prevState.openRecordPopup && this.state.openRecordPopup) {
      this.startRecordingTimeout = setTimeout(() => {
        this.startRecording();
      }, 2000);
      // this.startRecording(); // starts immediately
      // Delay playback specifically by 2s
      this.playAudioTimeout = setTimeout(() => {
        const streamUrl = `https://samedia.trackeazy.com/m3u8/${this.state.sessionNo}.m3u8`;
        this.playAudioStream(streamUrl);
      }, 2000);
    }

    // Card just closed
    if (prevState.openRecordPopup && !this.state.openRecordPopup) {
      if (this.playAudioTimeout) {
        clearTimeout(this.playAudioTimeout);
        this.playAudioTimeout = null;
      }
      this.stopAudioStream();
    }
  }

  handleEsc = (e) => {
    if (e.key === "Escape") {
      this.setState({ focusChartForDownload: false });
    }
  };

  getPlaybackUrl = async (info, parent, MDVR) => {

    const host = parent?.cmsvssWebHost;
    const imei = parent?.full_imei;
    const UserName = parent?.cmsvssUserName;
    const Password = parent?.cmsvssPassword;
    const channelId = info.node.channelId;
    const deviceId = parent?.deviceId;

    if (MDVR === "JT1078") {
      const data = {
        channelId: channelId,
        vehicleId: parent.vehicleId,
        full_imei: imei,
      };

      await this.videoMonitoringStore.bsjVideoMonitoring(data);

      var url =
        "https://samedia.trackeazy.com/video/" + imei + "-" + channelId;
      return url;

    } else if (MDVR === "CMS") {

      const iframeSrc = `${host}/808gps/open/player/video.html?lang=en&devIdno=${imei}&account=${UserName}&password=${Password}&channel=1&chns=${channelId - 1
        }`;

      return iframeSrc;
    } else if (MDVR === "H-Protocol") {
      const mdvrdata = {
        vehicleId: parent.vehicleId,
        channelId: channelId,
        deviceId: deviceId,
        full_imei: imei,
      };

      await this.videoMonitoringStore.howenMDVRSocket(mdvrdata);
      var chkVdoStatus = "https://samedia.trackeazy.com/howen/videostatus/live_" + imei + "_0" + channelId + "_00";

      var url = "https://samedia.trackeazy.com/m3u8/live_" + imei + "_0" + channelId + "_00.m3u8?ts=" + Date.now();
      this.setState({ channelId });
      await this.setState((prevState) => ({
        iframeSrcs: [
          ...prevState.iframeSrcs,
          { key: info.node.key, src: url, title: info.node.title, mdvr: "H-Protocol", chkvdoStatus: "initiated" },
        ],
      }));
      let count = 0;
      const interval = setInterval(() => {
        count++;

        fetch(chkVdoStatus)
          .then((res) => res.json())
          .then((data) => {
            // console.log(data, "video status");

            this.setState((prevState) => ({
              iframeSrcs: prevState.iframeSrcs.map((iframe) => {
                if (iframe.key !== info.node.key) {
                  return iframe;
                }

                // stream started
                if (data.message === "started") {
                  clearInterval(interval);
                  return {
                    ...iframe, chkvdoStatus: "started",
                  };
                }
                // pending or tag not found
                if (
                  data.message === "pending" ||
                  data.message === "Tag Not Found"
                ) {
                  if (count >= 15) {
                    clearInterval(interval);
                    return {
                      ...iframe,
                      chkvdoStatus: "not_available",
                    };
                  }

                  return {
                    ...iframe,
                    chkvdoStatus: "pending",
                  };
                }

                return iframe;
              }),
            }));
          })
          .catch((err) => {
            // console.log(err);

            if (count >= 15) {
              clearInterval(interval);

              this.setState((prevState) => ({
                iframeSrcs: prevState.iframeSrcs.map((iframe) => {
                  if (iframe.key !== info.node.key) {
                    return iframe;
                  }

                  return {
                    ...iframe,
                    chkvdoStatus: "not_available",
                  };
                }),
              }));
            }
          });

        if (count >= 15) {
          clearInterval(interval);
        }
      }, 1000);


      return url;
    } else {
      const port = parent?.cmsvssWebPort;
      const token = parent?.token;

      let iframeSrc = "";

      if (port != null) {
        iframeSrc = `${host}:${port}/vss/apiPage/RealVideo.html?token=${token}&deviceId=${imei}&chs=${channelId}&stream=0&wnum=0&buffer=0&panel=1`;
      } else {
        iframeSrc = `${host}/vss/apiPage/RealVideo.html?token=${token}&deviceId=${imei}&chs=${channelId}&stream=0&wnum=0&buffer=0&panel=1`;
      }
      // console.log(iframeSrc);
      return iframeSrc;
    }

  }

  getLayoutByChannelCount = (count) => {
    if (count === 1) return "ONE";
    if (count === 2) return "TWO";
    if (count > 2 & count <= 4) return "FOUR";
    return "NINE";
  };

  handleVideoChange = async (info) => {

    const childKey = info.node.vehicleId;

    if (info.checkedNodes.length > 0) {
      this.setState({ showDefaultImage: false });
    }
    else {
      this.setState({ showDefaultImage: true });
    }

    const parent = await this.findParent(
      this.videoMonitoringStore.deviceListArray,
      childKey
    );

    if (!parent) return; // stop if not found

    const MDVR = parent?.MDVR;

    const companyId = parent.vehicleId;
    const companyName = parent.vehicleNo;

    const channelKey = info.node.key;

    const checked = info.checked;

    if (checked) {
      const url = await this.getPlaybackUrl(info, parent, MDVR); // your existing method

      const channelObj = {
        key: channelKey,
        src: url,
        title: (info.node.vehicleNo + " - " + info.node.title),
        mdvr: MDVR,
      };

      this.setState(prevState => {
        const groups = { ...prevState.videoGroups };

        if (!groups[companyId]) {
          groups[companyId] = {
            companyName,
            companyId,
            channels: [],
          };
        }

        // avoid duplicate channel
        const exists = groups[companyId].channels.some(
          ch => ch.key === channelKey
        );

        if (!exists) {
          groups[companyId].channels.push(channelObj);
        }

        const channelCount = groups[companyId].channels.length;
        const autoLayout = this.getLayoutByChannelCount(channelCount);

        return {
          videoGroups: groups,
          selectedLayoutByCompany: {
            ...prevState.selectedLayoutByCompany,
            [companyId]: autoLayout
          }
        };
      });
    } else {
      // UNCHECK
      this.setState(prevState => {
        const groups = { ...prevState.videoGroups };

        if (groups[companyId]) {
          groups[companyId].channels =
            groups[companyId].channels.filter(
              ch => ch.key !== channelKey
            );

          if (groups[companyId].channels.length === 0) {
            delete groups[companyId];
          }
        }

        const channelCount = groups[companyId]?.channels.length || 0;
        const autoLayout = this.getLayoutByChannelCount(channelCount);

        return {
          videoGroups: groups,
          selectedLayoutByCompany: {
            ...prevState.selectedLayoutByCompany,
            [companyId]: autoLayout
          }
        };
      });
    }



  };
  renderTreeNodes = (data) => {
    return data?.map((item) => {
      const isParent = item?.children && item.children?.length > 0;
      return {
        ...item,
        disableCheckbox: isParent,
        title: (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "35px 1fr 20px",
              alignItems: "center",
              width: "170px", // adjust according to your left panel width
              columnGap: 8,
            }}
          >
            <Image
              width={35}
              preview={false}
              src={require("../assets/images/detailtracking/" + item.listImage)}
            />

            <span
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {item.text || item.title}
            </span>

            <Image
              width={15}
              preview={false}
              style={{ cursor: "pointer" }}
              src={require("../assets/images/signal-icon.png")}
              onClick={async (e) => {
                e.stopPropagation();
                // if (item.acc == null || (item.acc == 1 && item.speed > 0) || item.acc == ) {
                message.loading("Connecting...", 2);
                const timestamp = Date.now();

                await this.videoMonitoringStore.sendAudioCommandToSocket({
                  imeiNo: item.full_imei,
                  status: "1",
                  sessionNo: `voice_${item.full_imei}_${timestamp}`
                })
                this.setState({ recordImei: item.full_imei, openRecordPopup: true, sessionNo: `voice_${item.full_imei}_${timestamp}` })

                // await this.callStartRecordingFunction()

                // setTimeout(() => {
                //   this.setState({ openRecordPopup: true });
                // }, 2000);
                // } else {
                //   message.warning("Device is offline.");
                // }


              }}
            />
          </div>
        )
      };
    });
  };

  toggleCompanyFullscreen = (companyId) => {
    const el = document.getElementById(`company-panel-${companyId}`);

    if (!el) return;

    // If already fullscreen → exit
    if (document.fullscreenElement) {
      document.exitFullscreen();
      this.setState({ fullscreenCompanyId: null });
    } else {
      el.requestFullscreen();
      this.setState({ fullscreenCompanyId: companyId });
    }
  };

  handleBackClick = async () => {
    await this.setState({
      playbackVideoUrl: "",
      showVideoWindow: false,
      howenplaybackVideoUrl: "",
      showHowenVideoWindow: false,
      openCard: true,
      showPlaybackTable: false,
      showHowenPlaybackTable: false,
      showPlaybackvideoPanel: false,
      showDefaultImage: true,
    });
  };

  openModal = (iframe) => {
    this.setState((prevState) => ({
      openVideoModal: true,
      selectedIframe: iframe,
      hiddenIframeKeys: [...prevState.hiddenIframeKeys, iframe.key],
    }));
  };

  closeModal = () => {
    this.setState((prevState) => ({
      openVideoModal: false,
      hiddenIframeKeys: prevState.hiddenIframeKeys.filter(
        (key) => key !== prevState.selectedIframe?.key
      ),
      selectedIframe: null,
    }));
  };

  findParent = async (tree, key) => {
    for (const node of tree) {
      if (node.vehicleId === key) {
        return node;
      }
      if (node.children) {
        const found = await this.findParent(node.children, key);
        if (found) return node;
      }
    }
    return null;
  };

  async handleDownload(record) {
    // console.log(record, "record");
    const data = {
      companyId: this.state.companyId,
      channelId: record.channelNo,
      vehicleId: this.state.vehicleId,
      starttime: record.startTime,
      endTime: record.endTime,
      isDownload: 1
    };
    // const videoData=false
    const videoData = await this.videoMonitoringStore.gethowenPlaybackVideoData(
      data
    );

    if (videoData) {
      data.url = videoData.url
      data.fileName = videoData.fileName
      data.sessionNo = videoData.sessionNo
      data.filesize = record.filesize
      const res = await this.videoMonitoringStore.downloadHowenVideo(data);
      if (res.success) {
        message.success(res.message);
        const data1 = {
          companyId: this.state.companyId,
          channelId: record.channelNo,
          vehicleId: this.state.vehicleId,
          starttime: this.state.fromDate,
          endTime: this.state.toDate,
          isDownload: 1
        };

        const response = await this.videoMonitoringStore.gethowenPlaybackData(data1);
        this.setState({ loadData: 1 })

      } else {
        message.error("Something went wrong");
      }

    }

  };

  convertMinutesTo12Hour = (minutes) => {
    if (minutes == null) return "";

    // Ensure minutes are in 0-1440
    minutes = Math.min(Math.max(minutes, 0), 1440);

    let h = Math.floor(minutes / 60);
    let m = minutes % 60;

    // AM / PM
    const ampm = h >= 12 && h < 24 ? "PM" : "AM";

    h = h % 12;
    if (h === 0) h = 12;

    // pad minutes
    const mm = m.toString().padStart(2, "0");

    return `${h}:${mm} ${ampm}`;
  };

  getNearestHalfHour = () => {
    const now = dayjs();
    const minutes = now.minute();
    const roundedMinutes = Math.round(minutes / 30) * 30;
    return now.minute(roundedMinutes).second(0).format("HH:mm:ss");

  };

  convertMinutesTo24Hour = (minutes) => {
    if (minutes == null) return "";

    // Ensure minutes are in 0-1440
    minutes = Math.min(Math.max(minutes, 0), 1440);

    let h = Math.floor(minutes / 60);
    let m = minutes % 60;

    // AM / PM
    // const ampm = h >= 12 && h < 24 ? "PM" : "AM";

    // h = h % 12;
    // if (h === 0) h = 12;

    // pad minutes
    const mm = m.toString().padStart(2, "0");
    const hh = h.toString().padStart(2, "0");

    return `${hh}:${mm}:00`;
  };

  handleDownloadVideoList = async () => {

    this.setState({
      showDownloadedVideoList: false, showVideoWindow: false, showHowenVideoWindow: false, activeRow: null,
      showPlaybackPanel: false, openCard: false, showDefaultImage: false
    });
    //form values will be here  
    const values = this.formRef.current.getFieldsValue();
    const channelId = [1, 2, 3, 4, 5, 6, 7, 8];
    // const fromDate = this.state.fromDate;
    // const toDate = this.state.toDate;

    const fromDate = dayjs(values.fromDate).format("YYYY-MM-DD");
    const toDate = dayjs(values.fromDate).format("YYYY-MM-DD");
    const fromTime = values.fromTime;
    const toTime = values.toTime;;


    const data = {
      vehicleId: this.state.vehicleId,
      channelId: channelId,
      fromDate: fromDate + " " + fromTime,
      toDate: toDate + " " + toTime,
    };
    const res = await this.videoMonitoringStore.fetchDownloadVideoList(data);
    if (res) {
      const filteredData = this.state.treeData?.filter(
        (item) => item.vehicleId === this.state.vehicleId
      );
      const MDVR = filteredData[0]?.MDVR;

      this.setState({ mdvr: MDVR });

      await this.setState({ loadData: 1, showDownloadedVideoList: true, showPlaybackTable: false, showHowenPlaybackTable: false, showPlaybackvideoPanel: false, playbackView: "TABLE" });

    } else {
      message.error("Something went wrong");
    }
  }

  getPolylineData = async () => {

    const values = this.formRef.current.getFieldsValue();
    const fromDate = dayjs(values.fromDate).format("YYYY-MM-DD");
    const toDate = dayjs(values.fromDate).format("YYYY-MM-DD");

    await this.vehicleOtherInfoStore.getVehicleHistoryData({
      vehicleId: this.state.vehicleId,
      companyId: this.state.companyId,
      fromDate: fromDate + " " + values.fromTime,
      toDate: toDate + " " + values.toTime,
    });
    await this.clearMap();

    await this.vehicleOtherInfoStore.setOfflineData({
      vehicleId: this.state.vehicleId,
      companyId: this.state.companyId,
      fromDate: fromDate + " " + values.fromTime,
      toDate: toDate + " " + values.toTime,
      resetOffset: 0,
    });

    await this.showPolyline();
  };

  clearMap = async () => {

    if (this.mapRef.current && this.removeMarkerPoints.length > 0) {
      this.mapRef.current.eachLayer((layer) => {
        if (layer instanceof L.Marker) {
          const markerLatLng = layer.getLatLng();
          // Check if the marker's coordinates are in the removeMarkerPoints array
          const isMarkerInRemovePoints = this.removeMarkerPoints.some((point) =>
            markerLatLng.equals(L.latLng(point))
          );
          if (isMarkerInRemovePoints) {
            // If the marker's coordinates are in the removeMarkerPoints array, remove it from the map
            this.mapRef.current.removeLayer(layer);
          }
        }
      });
    }
    if (this.mapRef) {
      await this.mapRef?.current?.eachLayer((layer) => {
        if (layer instanceof L.Polyline) {
          this.mapRef.current.removeLayer(layer);
        }
      });
    }
    this.vehicleOtherInfoStore.offlineData = [];
    this.vehicleOtherInfoStore.offlineDataNewObj = [];
    this.vehicleOtherInfoStore.idleAndStopPointsArray = [];
    this.vehicleOtherInfoStore.totalCount = null;
    this.vehicleOtherInfoStore.total = 0;
    this.vehicleOtherInfoStore.pgcount = 1;
    this.vehicleOtherInfoStore.offset = 0;

    // await this.clearFuelIcons();
  };

  showPolyline = async () => {
    // Remove existing polyline if any
    if (this.polyline) {
      this.mapRef.current.removeLayer(this.polyline);
    }

    this.polyline = L.polyline(
      this.vehicleOtherInfoStore.offlineDataNewObj.length > 0
        ? [...this.vehicleOtherInfoStore.offlineDataNewObj]
        : [],
      {
        color: "grey",
        smoothFactor: 5,
        weight: 4,
      }
    ).addTo(this.mapRef.current);

    const bounds = this.polyline.getBounds();

    if (bounds.isValid()) {
      this.mapRef.current.fitBounds(bounds, {
        maxZoom: 20,
        padding: [50, 50] // Add some padding
      });
    }

    // Add arrowheads with frequency option
    this.polyline.arrowheads({
      size: "6px",
      frequency: "50px", // Add arrow every 50 pixels
      color: "blue",
      fill: true
    });

    // Force redraw arrowheads on zoom end
    this.mapRef.current.on('zoomend', () => {
      if (this.polyline && this.polyline._arrowheads) {
        this.polyline.arrowheads({
          size: "6px",
          frequency: "50px",
          color: "blue",
          fill: true
        });
      }
    });

    // Trigger initial arrowhead rendering after a short delay
    setTimeout(() => {
      if (this.polyline) {
        this.polyline.redraw();
      }
    }, 300);
  };


  getColumns = () => {
    return [
      {
        title: this.context.translate("_CHANNEL_"),
        dataIndex: this.state.mdvr === "H-Protocol" ? "channelNo" : "logicalChannelNumber",
        width: "12%",
        render: (text, record) =>
          this.state.mdvr === "H-Protocol"
            ? record.channelNo
            : record.logicalChannelNumber ?? "",
      },
      {
        title: this.context.translate("_STARTTIME_"),
        dataIndex: "startTime",
        width: "18%",
      },
      {
        title: this.context.translate("_END_TIME_"),
        dataIndex: "endTime",
        width: "18%",
      },
      ...(!this.state.showDownloadedVideoList
        ? [
          {
            title: this.context.translate("_PLAY_"),
            width: "10%",
            align: "center",
            render: (text, record) => (
              <div style={{ display: "flex", alignItems: "center" }}>
                {this.state.activeRow === record.startTime ? (
                  <Tooltip title={"Pause"} color="green">
                    <PauseCircle
                      style={{ fontSize: "20px", cursor: "pointer" }}
                      onClick={() => {
                        this.setState({
                          activeRow: null,
                          showVideoWindow: false,
                          showHowenVideoWindow: false,
                          playbackVideoUrl: "",
                          howenplaybackVideoUrl: "",
                        });
                        if (this.state.mdvr === "JT1078") {
                          this.videoMonitoringStore.stopBsjVideo(record);
                        }
                      }}
                    />
                  </Tooltip>
                ) : (
                  <Tooltip title={"Play"} color="green">
                    <PlayCircle
                      style={{ fontSize: "20px", cursor: "pointer" }}
                      onClick={() => {
                        if (this.state.mdvr === "JT1078") {
                          if (this.state.channelId === record.logicalChannelNumber) {
                            Modal.warning({
                              title: this.context.translate(
                                "_FLEET_DASHBORD_SHOWGEO_REMOVEALERT_"
                              ),
                              content: this.context.translate(
                                "Live streaming is currently active on this channel, so playback of recorded videos is unavailable."
                              ),
                            });
                          } else {
                            this.handlePlaybackVideo(record);
                            this.setState({
                              activeRow: record.startTime,
                              showVideoWindow: true,
                            });
                          }
                        } else {
                          this.handleHowenPlaybackVideo(record);
                          this.setState({
                            activeRow: record.startTime,
                            showHowenVideoWindow: true,
                          });
                        }
                      }}
                    />
                  </Tooltip>
                )}
              </div>
            ),
          },
        ]
        : [

          {
            title: this.context.translate("_PLAY_"),
            width: "10%",
            align: "center",
            render: (text, record) => (
              <div style={{ display: "flex", alignItems: "center" }}>
                {this.state.activeRow === record.startTime ? (
                  <Tooltip title={"Pause"} color="green">
                    <PauseCircle
                      style={{ fontSize: "20px", cursor: "pointer" }}
                      onClick={() => {
                        this.setState({
                          activeRow: null,
                          showVideoWindow: false,
                          showHowenVideoWindow: false,
                          playbackVideoUrl: "",
                          howenplaybackVideoUrl: "",
                        });

                      }}
                    />
                  </Tooltip>
                ) : (
                  // <Tooltip title={"Play"} color="green">
                  // <PlayCircle
                  //   style={{ fontSize: "20px", cursor: "pointer" }}
                  //   onClick={async () => {
                  //     console.log("errree")
                  //     if (this.state.activeRow === record.startTime) {

                  //       this.setState({
                  //         activeRow: null,
                  //         showHowenVideoWindow: false,
                  //         howenplaybackVideoUrl: ""
                  //       });
                  //     } else {


                  //       await this.setState({
                  //         selectedChannels: [record.channelNo]
                  //       });
                  //       this.handlePlaybackPointClick(record);
                  //     }
                  //   }}

                  // />
                  // </Tooltip>
                  <Tooltip title={"Play"} color="black">
                    {record.isFileAvailable ? (
                      <PlayCircle
                        style={{ fontSize: "20px", cursor: "pointer" }}
                        onClick={async () => {
                          // console.log("errree")
                          if (this.state.activeRow === record.startTime) {

                            this.setState({
                              activeRow: null,
                              showHowenVideoWindow: false,
                              howenplaybackVideoUrl: ""
                            });
                          } else {


                            await this.setState({
                              selectedChannels: [record.channelNo]
                            });
                            this.handlePlaybackPointClick(record);
                          }
                        }}

                      />
                    ) : (
                      <img
                        src={require("../assets/images/processing-time.png")}
                        alt="Processing"
                        style={{ width: 18, height: 18, cursor: "not-allowed", marginLeft: 10 }}
                      />
                    )}

                  </Tooltip>

                )}
              </div>
            )
          }
        ]),
      ...(!this.state.showDownloadedVideoList
        ? [
          {
            title: this.context.translate("Download"),
            width: "15%",
            align: "center",
            render: (text, record) => (
              <Tooltip title={"Download"} color="black">
                {record.isFileAvailable ? (
                  <img
                    src={require("../assets/images/download.png")}
                    alt="Download"
                    style={{ width: 23, height: 23, cursor: "pointer" }}
                    onClick={() => this.handleDownload(record)}
                  />
                ) : (
                  <img
                    src={require("../assets/images/processing-time.png")}
                    alt="Processing"
                    style={{ width: 23, height: 23, cursor: "not-allowed" }}
                  />
                )}

              </Tooltip>
            ),
          },
        ]
        : []),
    ];
  };

  closeRecordPopup = async () => {
    // 1. Hide the popup and reset UI state FIRST — instant visual feedback
    this.setState({
      openRecordPopup: false,
      recordError: null,
      uploadSuccess: false,
      sessionNo: null,
      isRecording: false,
    });

    // 2. Now do all the teardown work in the background — user already sees it closed
    if (this.uploadInterval) {
      clearInterval(this.uploadInterval);
      this.uploadInterval = null;
    }

    const imei = this.state.recordImei;
    const sessionNo = this.state.sessionNo;

    this.stopRecording();

    await this.videoMonitoringStore.sendAudioCommandToSocket({
      imeiNo: imei,
      status: "0",
      sessionNo: sessionNo,
    });
  };

  // closeRecordPopup = async () => {
  //   if (this.uploadInterval) {
  //     clearInterval(this.uploadInterval);
  //     this.uploadInterval = null;
  //   }
  //   this.stopRecording(); // idempotent version from before — safe even if already stopped
  //   this.setState({
  //     openRecordPopup: false,
  //     recordError: null,
  //     uploadSuccess: false,
  //     sessionNo: null,
  //     isRecording: false
  //   });
  //   await this.videoMonitoringStore.sendAudioCommandToSocket({
  //     imeiNo: this.state.recordImei,
  //     status: "0",
  //     sessionNo: this.state.sessionNo
  //   });

  // };
  playAudioStream = (url) => {
    const audio = this.audioRef.current;
    if (!audio) return;

    if (this.hlsInstance) {
      this.hlsInstance.destroy();
      this.hlsInstance = null;
    }

    if (Hls.isSupported()) {
      const hls = new Hls({
        debug: true,
        startPosition: -1,              // start at live edge, not playlist start
        liveSyncDurationCount: 1,        // ↓ from 3 — target only 1 segment back from live edge
        liveMaxLatencyDurationCount: 3,  // ↓ from 6 — if we fall further behind than this, force a jump to live
        maxFragLookUpTolerance: 0.25,
        backBufferLength: 0,             // don't retain old segments at all
        maxLiveSyncPlaybackRate: 1.5,    // NEW — speed up slightly (up to 1.5x) to catch up to live edge if lagging, instead of just jumping
        liveDurationInfinity: true,      // NEW — treat this as a true infinite live stream (no seekable "end")
      });
      this.hlsInstance = hls;

      hls.loadSource(url);
      hls.attachMedia(audio);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        if (hls.liveSyncPosition != null) {
          audio.currentTime = hls.liveSyncPosition;
        }
        audio.play().catch((err) => {
          console.error('Playback failed:', err);
          this.setState({ streamError: 'Unable to play audio stream.' });
        });
      });

      // NEW — every time the playlist updates with new segments, check if we've
      // drifted behind the live edge and snap back if so
      hls.on(Hls.Events.LEVEL_UPDATED, () => {
        if (hls.liveSyncPosition == null) return;

        const drift = hls.liveSyncPosition - audio.currentTime;
        // If we're more than ~2s behind the live edge, jump forward
        if (drift > 2) {
          console.warn(`Drifted ${drift.toFixed(2)}s behind live edge, resyncing`);
          audio.currentTime = hls.liveSyncPosition;
        }
      });

      hls.on(Hls.Events.ERROR, (event, data) => {
        console.error('HLS error:', data.type, data.details, data.fatal);
        if (data.fatal) {
          switch (data.type) {
            case Hls.ErrorTypes.NETWORK_ERROR:
              console.warn('Fatal network error, trying to recover...');
              hls.startLoad();
              break;
            case Hls.ErrorTypes.MEDIA_ERROR:
              console.warn('Fatal media error, trying to recover...');
              hls.recoverMediaError();
              break;
            default:
              this.setState({ streamError: 'Stream error occurred.' });
              hls.destroy();
              break;
          }
        }
      });
    } else if (audio.canPlayType('application/vnd.apple.mpegurl')) {
      audio.src = url;
      audio.play().catch((err) => {
        console.error('Playback failed:', err);
        this.setState({ streamError: 'Unable to play audio stream.' });
      });
    } else {
      this.setState({ streamError: 'HLS playback not supported in this browser.' });
    }
  };

  // playAudioStream = (url) => {
  //   const audio = this.audioRef.current;
  //   if (!audio) return;
  //   // Clean up any previous instance first
  //   if (this.hlsInstance) {
  //     this.hlsInstance.destroy();
  //     this.hlsInstance = null;
  //   }

  //   if (Hls.isSupported()) {
  //     const hls = new Hls({
  //       debug: true,
  //       startPosition: -1,
  //       liveSyncDurationCount: 3,
  //       liveMaxLatencyDurationCount: 6,
  //       maxFragLookUpTolerance: 0.25,
  //       backBufferLength: 0,
  //     });
  //     this.hlsInstance = hls;

  //     hls.loadSource(url);
  //     hls.attachMedia(audio);

  //     hls.on(Hls.Events.MANIFEST_PARSED, () => {
  //       if (hls.liveSyncPosition != null) {
  //         audio.currentTime = hls.liveSyncPosition;
  //       }

  //       audio.play().catch((err) => {
  //         console.error('Playback failed:', err);
  //         this.setState({ streamError: 'Unable to play audio stream.' });
  //       });
  //     });

  //     hls.on(Hls.Events.ERROR, (event, data) => {
  //       console.error('HLS error:', data.type, data.details, data.fatal);

  //       if (data.fatal) {
  //         switch (data.type) {
  //           case Hls.ErrorTypes.NETWORK_ERROR:
  //             console.warn('Fatal network error, trying to recover...');
  //             hls.startLoad();
  //             break;
  //           case Hls.ErrorTypes.MEDIA_ERROR:
  //             console.warn('Fatal media error, trying to recover...');
  //             hls.recoverMediaError();
  //             break;
  //           default:
  //             this.setState({ streamError: 'Stream error occurred.' });
  //             hls.destroy();
  //             break;
  //         }
  //       }
  //     });
  //   } else if (audio.canPlayType('application/vnd.apple.mpegurl')) {
  //     // Safari has native HLS support — no hls.js needed
  //     audio.src = url;
  //     audio.play().catch((err) => {
  //       console.error('Playback failed:', err);
  //       this.setState({ streamError: 'Unable to play audio stream.' });
  //     });
  //   } else {
  //     this.setState({ streamError: 'HLS playback not supported in this browser.' });
  //   }
  // };

  stopAudioStream = () => {
    if (this.hlsInstance) {
      this.hlsInstance.destroy();
      this.hlsInstance = null;
    }
    const audio = this.audioRef.current;
    if (audio) {
      audio.pause();
      audio.src = '';
    }
  }

  startRecording = async () => {
    try {
      this.setState({ recordError: null, uploadSuccess: false, isRecording: false });

      const stream = await navigator.mediaDevices.getUserMedia({
        audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true },
      });
      this.audioStream = stream;

      this.peerConnection = new RTCPeerConnection({
        iceServers: [{ urls: 'stun:stun.l.google.com:19302' }],
      });

      stream.getTracks().forEach((track) => {
        this.peerConnection.addTrack(track, stream);
      });

      this.peerConnection.onconnectionstatechange = () => {
        const state = this.peerConnection.connectionState;
        console.log('WebRTC connection state:', state);

        if (state === 'connected') {
          this.setState({ isRecording: true });
        } else if (state === 'failed' || state === 'closed') {
          this.setState({ isRecording: false });
        }
        // ignore 'disconnected' / 'connecting' — transient, self-recovering
      };

      const offer = await this.peerConnection.createOffer();
      await this.peerConnection.setLocalDescription(offer);
      await this.waitForIceGatheringComplete(this.peerConnection);

      const response = await axios.post(
        `http://130.110.114.14:22107/webrtc/offer?imei=${encodeURIComponent(this.state.sessionNo)}`,
        this.peerConnection.localDescription.sdp,
        { headers: { 'Content-Type': 'application/sdp' }, timeout: 10000 }
      );

      await this.peerConnection.setRemoteDescription({
        type: 'answer',
        sdp: response.data,
      });

      this.setState({ isRecording: true });
    } catch (err) {
      console.error('WebRTC start error:', err);

      let errorMessage = 'Device is unreachable at the moment. Please try again.';
      if (err.name === 'NotAllowedError') {
        errorMessage = 'Microphone permission denied. Please allow access in browser settings.';
      } else if (err.response?.data) {
        errorMessage =
          typeof err.response.data === 'string'
            ? err.response.data
            : err.response.data?.message || errorMessage;
      } else if (err.message) {
        errorMessage = err.message;
      }

      message.error(errorMessage);
      this.setState({ recordError: errorMessage, isRecording: false });

      this.stopRecording();
      this.closeRecordPopup();
    }
  };

  // startRecording = async () => {
  //   try {
  //     this.setState({ recordError: null, uploadSuccess: false, isRecording: false });

  //     const stream = await navigator.mediaDevices.getUserMedia({
  //       audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true },
  //     });
  //     this.audioStream = stream;

  //     this.peerConnection = new RTCPeerConnection({
  //       iceServers: [{ urls: 'stun:stun.l.google.com:19302' }],
  //     });

  //     stream.getTracks().forEach((track) => {
  //       this.peerConnection.addTrack(track, stream);
  //     });

  //     this.peerConnection.onconnectionstatechange = () => {
  //       console.log('WebRTC connection state:', this.peerConnection.connectionState);
  //       if (['disconnected', 'failed', 'closed'].includes(this.peerConnection.connectionState)) {
  //         this.setState({ isRecording: false });
  //       }
  //     };

  //     const offer = await this.peerConnection.createOffer();
  //     await this.peerConnection.setLocalDescription(offer);
  //     await this.waitForIceGatheringComplete(this.peerConnection);
  //     console.log("all test passed")
  //     const response = await axios.post(
  //       `http://130.110.114.14:22107/webrtc/offer?imei=${encodeURIComponent(this.state.sessionNo)}`,
  //       this.peerConnection.localDescription.sdp,
  //       { headers: { 'Content-Type': 'application/sdp' }, timeout: 10000 }
  //     );

  //     await this.peerConnection.setRemoteDescription({
  //       type: 'answer',
  //       sdp: response.data,
  //     });

  //     this.setState({ isRecording: true });
  //   } catch (err) {
  //     console.error('WebRTC start error:', err);

  //     // Extract a clean, user-readable message from whichever error shape this is
  //     let errorMessage = 'Device is unreachable at the moment. Please try again.';

  //     if (err.name === 'NotAllowedError') {
  //       errorMessage = 'Microphone permission denied. Please allow access in browser settings.';
  //     } else if (err.response?.data) {
  //       // Server responded with an error (e.g. 400 "Device session not found for IMEI ...")
  //       errorMessage =
  //         typeof err.response.data === 'string'
  //           ? err.response.data
  //           : err.response.data?.message || errorMessage;
  //     } else if (err.message) {
  //       errorMessage = err.message;
  //     }
  //     // console.log(errorMessage, "errorMessage")
  //     message.error(errorMessage); // show it as a toast immediately
  //     this.setState({
  //       recordError: errorMessage,
  //       isRecording: false,
  //     });

  //     this.stopRecording();
  //     this.closeRecordPopup(); // optional — close the popup automatically on failure, see note below
  //   }
  // };

  waitForIceGatheringComplete = (pc, maxWaitMs = 2500) => {
    if (pc.iceGatheringState === 'complete') return Promise.resolve();

    return new Promise((resolve) => {
      const check = () => {
        if (pc.iceGatheringState === 'complete') {
          pc.removeEventListener('icegatheringstatechange', check);
          clearTimeout(timer);
          resolve();
        }
      };
      pc.addEventListener('icegatheringstatechange', check);

      const timer = setTimeout(() => {
        console.warn(`ICE gathering timed out after ${maxWaitMs}ms, proceeding with what we have`);
        pc.removeEventListener('icegatheringstatechange', check);
        resolve();
      }, maxWaitMs);
    });
  };
  // stopRecording = () => {
  //   if (this.disconnectGraceTimer) {
  //     clearTimeout(this.disconnectGraceTimer);
  //     this.disconnectGraceTimer = null;
  //   }
  //   this.audioStream?.getTracks().forEach((t) => t.stop());
  //   this.audioStream = null;

  //   if (this.peerConnection) {
  //     this.peerConnection.close();
  //     this.peerConnection = null;
  //   }

  //   this.setState({ isRecording: false });
  // };

  stopRecording = () => {
    if (this.disconnectGraceTimer) {
      clearTimeout(this.disconnectGraceTimer);
      this.disconnectGraceTimer = null;
    }
    this.audioStream?.getTracks().forEach((t) => t.stop());
    this.audioStream = null;

    if (this.peerConnection) {
      this.peerConnection.close();
      this.peerConnection = null;
    }

    this.setState((prev) => (prev.isRecording ? { isRecording: false } : null)); // no-op if already false
  };

  render() {
    return (
      <div className="listHeader">

        <div>
          <Row className="video-monitoring">
            <Col span={4} className="live-video-streaming-block">
              <div className="heading">
                {this.context.translate("_LIVE_VIDEO_STREAMING_")}
              </div>
              <CompanyAutocomplete
                onChange={(v) => this.handleChange(v)}
                style={{ padding: "10px", width: "100%" }}
              />

              <Tree
                checkable
                showIcon
                showLine={true}
                checkedKeys={this.state.checkedKeys}
                onCheck={(checkedKeys, info) => {
                  this.setState({ checkedKeys });
                  this.handleVideoChange(info);
                  this.setState({
                    playbackVideoUrl: "",
                    showVideoWindow: false,
                    howenplaybackVideoUrl: "",
                    showHowenVideoWindow: false,
                    openCard: true,
                    showPlaybackTable: false,
                    showHowenPlaybackTable: false,
                    showPlaybackvideoPanel: false,
                  });
                }}
                treeData={this.renderTreeNodes(
                  this.videoMonitoringStore.deviceListArray
                )}
              />
            </Col>
            {
              this.state.showDefaultImage &&
              <Col span={20} style={{ height: "90vh" }}>
                {/* <img
                  src={require("../assets/images/video-monitoring-default.png")}
                  alt="Default"
                  preview={false}
                  style={{ width: '100%', height: '100%', objectFit: 'fill' }}
                /> */}

                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "20px",
                    margin: "5px",
                  }}
                >


                  <div style={{ display: "block", width: "100%" }}>
                    {this.state.openCard &&
                      [1].map((company) => {
                        const selectedLayoutId =
                          this.state.selectedLayoutByCompany[null] || "FOUR";
                        const layout = LAYOUTS[selectedLayoutId];
                        return (
                          <div
                            id={`company-panel-${company}`}
                            className="company-panel-video-monitoring"
                            key={company}
                            style={{
                              width: "100%",
                              marginBottom: 36,
                              padding: "16px 16px 20px",
                              backgroundColor: "#ffffff",
                              borderRadius: 12,
                              boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                              borderLeft: "6px solid #2563eb", // strong visual separator
                            }}
                          >
                            {/* Company Header */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginBottom: 16,
                                paddingBottom: 10,
                                borderBottom: "1px solid #e5e7eb",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: 17,
                                  fontWeight: 700,
                                  color: "#111827",
                                  letterSpacing: "0.3px",
                                }}
                              >
                                {"Company Name"}
                              </span>

                              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>


                                <span
                                  style={{
                                    fontSize: 12,
                                    color: "#6b7280",
                                    background: "#f1f5f9",
                                    padding: "4px 10px",
                                    borderRadius: 20,
                                    fontWeight: 500,
                                  }}
                                >
                                  {0} Channels
                                </span>


                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "20px",
                                paddingLeft: 12,
                              }}
                            >
                              <LayoutRenderer
                                layout={layout}
                                channels={company}
                                videoStatus={this.state.iframeSrcs}
                              />
                            </div>
                          </div>
                        )
                      })}
                  </div>
                </div>
              </Col>
            }
            {
              !this.state.showDefaultImage &&
              <Col span={20} style={{ height: "90vh", overflow: "auto" }}>
                <>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "20px",
                      margin: "5px",
                    }}
                  >


                    <div style={{ display: "block", width: "100%" }}>
                      {this.state.openCard &&
                        Object.values(this.state.videoGroups).map((company) => {
                          const selectedLayoutId =
                            this.state.selectedLayoutByCompany[company.companyId] || "ONE";
                          const layout = LAYOUTS[selectedLayoutId];
                          return (
                            <div
                              id={`company-panel-${company.companyName}`}
                              className="company-panel-video-monitoring"
                              key={company.companyId}
                              style={{
                                width: "100%",
                                marginBottom: 36,
                                padding: "16px 16px 20px",
                                backgroundColor: "#ffffff",
                                borderRadius: 12,
                                boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                                borderLeft: "6px solid #2563eb", // strong visual separator
                              }}
                            >
                              {/* Company Header */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  marginBottom: 16,
                                  paddingBottom: 10,
                                  borderBottom: "1px solid #e5e7eb",
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: 17,
                                    fontWeight: 700,
                                    color: "#111827",
                                    letterSpacing: "0.3px",
                                  }}
                                >
                                  {company.companyName}
                                </span>

                                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>

                                  <div style={{ display: "flex", gap: 8 }}>
                                    {LAYOUT_ICONS.map(icon => {
                                      const selected =
                                        this.state.selectedLayoutByCompany[company.companyId] === icon.id;

                                      return (
                                        <img
                                          key={icon.id}
                                          src={icon.img}
                                          title={icon.title}
                                          onClick={() =>
                                            this.handleLayoutChange(company.companyId, icon.id)
                                          }
                                          style={{
                                            width: 22,
                                            height: 22,
                                            cursor: "pointer",
                                            opacity: selected ? 1 : 0.5,
                                            borderBottom: selected ? "2px solid #2563eb" : "none"
                                          }}
                                        />
                                      );
                                    })}
                                  </div>
                                  <span
                                    style={{
                                      fontSize: 12,
                                      color: "#6b7280",
                                      background: "#f1f5f9",
                                      padding: "4px 10px",
                                      borderRadius: 20,
                                      fontWeight: 500,
                                    }}
                                  >
                                    {company.channels.length} Channels
                                  </span>

                                  <i
                                    className="bi bi-fullscreen"
                                    style={{
                                      fontSize: 16,
                                      cursor: "pointer",
                                      color: "#2563eb",
                                    }}
                                    title="Fullscreen"
                                    onClick={() =>
                                      this.toggleCompanyFullscreen(company.companyName)
                                    }
                                  />
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "20px",
                                  paddingLeft: 12,
                                }}
                              >
                                <LayoutRenderer
                                  layout={layout}
                                  channels={company.channels}
                                  videoStatus={this.state.iframeSrcs}

                                />
                              </div>
                            </div>
                          )
                        })}
                    </div>
                  </div>
                </>
                <Row span={12}>
                  <Col span={24} style={{ padding: "0 20px" }}>
                    {!this.state.openCard && (
                      <div
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: 12,
                          boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                          borderLeft: "6px solid #2563eb",
                          width: "100%",
                        }}
                      >
                        {/* Header Section */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "5px",
                            borderBottom: "1px solid #e5e7eb",
                          }}
                        >
                          <span
                            style={{
                              fontSize: 17,
                              fontWeight: 700,
                              color: "#111827",
                              letterSpacing: "0.3px",
                            }}
                          >
                            {this.state.selectedvehicleName ? (this.state.selectedvehicleName + " - ") : ""}   Playback Video
                          </span>

                          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <Tooltip title="Go Back">
                              <Button
                                type="text"
                                icon={<ArrowLeftOutlined />}
                                onClick={this.handleBackClick}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#6b7280",
                                  fontSize: 16,
                                }}
                              />
                            </Tooltip>
                          </div>
                        </div>

                        {/* Content Section */}
                        <div style={{ height: "220px", padding: "5px" }}>
                          {this.state.showPlaybackvideoPanel && !this.state.openCard && (
                            <DynamicGridRenderer
                              channels={this.state.multiPlaybackUrls}
                              onhandleDownloadChannel={this.handleDownloadChannel}
                            />
                          )}
                          {!this.state.showPlaybackvideoPanel && !this.state.openCard && (
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: 10,
                                border: "1px solid #e5e7eb",
                                padding: 10,
                              }}
                            >
                              <EmptySlot />
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
                {

                  !this.state.openCard &&
                  <div style={{
                    height: "calc(90vh - 220px)", // Adjust based on your playback video panel height
                    display: "flex",
                    gap: "20px",
                    padding: "0 20px"
                  }}>
                    {/* LEFT COLUMN - Chart/Table */}
                    <div style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      minWidth: 0
                    }}>
                      {/* Buttons */}
                      <div style={{
                        marginLeft: 20,
                        marginTop: 15,
                        marginBottom: 10,
                        flexShrink: 0
                      }}>
                        <img
                          src={require("../assets/images/download.png")}
                          alt="Download"
                          style={{
                            width: 20,
                            height: 20,
                            cursor: "pointer",
                            color: 'green'
                          }}
                          onClick={() => this.setState({ focusChartForDownload: true })}
                          title="Download"
                        />

                        <img
                          src={require("../assets/images/list.png")}
                          alt="Table View"
                          style={{
                            width: 20,
                            height: 20,
                            cursor: "pointer",
                            marginLeft: 10,
                            marginRight: 10,
                            border: this.state.playbackView === "TABLE" ? "2px solid blue" : "2px solid transparent",
                            borderRadius: 4,
                          }}
                          title="Table View"
                          onClick={() => this.setState({ playbackView: "TABLE" })}
                        />

                        <img
                          src={require("../assets/images/chart.png")}
                          alt="Chart View"
                          style={{
                            width: 20,
                            height: 20,
                            padding: 2,
                            cursor: "pointer",
                            border: this.state.playbackView === "CHART" ? "2px solid blue" : "2px solid transparent",
                            borderRadius: 4,
                          }}
                          title="Chart View"
                          onClick={() => this.setState({ playbackView: "CHART" })}
                        />
                      </div>

                      {/* CHART VIEW */}
                      {this.state.showHowenPlaybackTable && this.state.playbackView === "CHART" && (
                        <> {this.state.loadingData &&
                          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                            <Spin
                              spinning={this.state.loadingData}>

                            </Spin>
                          </div>
                        }
                          {

                            <div
                              ref={this.chartRef}
                              style={{
                                flex: 1,
                                paddingRight: "20px",
                                minHeight: 0,
                                overflow: "hidden"
                              }}
                            >
                              <ResponsiveContainer width="100%" height="100%">
                                <ScatterChart margin={{ top: 10, right: 20, left: 10, bottom: 0 }}>
                                  <CartesianGrid strokeDasharray="1 1" />

                                  <XAxis
                                    dataKey="time"
                                    type="number"
                                    name="Hour"
                                    domain={[0, 1440]}
                                    ticks={minuteTicks}
                                    allowDecimals={false}
                                    tickFormatter={(v) => {
                                      const h = Math.floor(v / 60);
                                      const m = v % 60;
                                      // console.log(`${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`);
                                      return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
                                    }}
                                    interval={2}
                                    height={80}
                                  />

                                  <YAxis
                                    dataKey="channelNo"
                                    type="number"
                                    name="channelNo"
                                    ticks={[1, 2, 3, 4, 5, 6, 7, 8]}
                                    domain={[0, 8]}
                                    interval={0}
                                    allowDecimals={false}
                                    tick={(props) => {
                                      const { y, payload } = props;
                                      const ch = payload.value;

                                      return (
                                        <svg>
                                          <foreignObject x={0} y={y - 10} width={50} height={18}>
                                            <div xmlns="http://www.w3.org/1999/xhtml" style={{ display: "flex", alignItems: "center" }}>
                                              <input
                                                type="checkbox"
                                                checked={this.state.selectedChannels.includes(ch)}
                                                onChange={() => this.toggleSelectedChannel(ch)}
                                                style={{ marginLeft: "5px", marginRight: "2px" }}
                                              />
                                              <span>CH{ch}</span>
                                            </div>
                                          </foreignObject>
                                        </svg>
                                      );
                                    }}
                                    width={50}
                                  />

                                  {this.state.isSelecting &&
                                    this.state.focusChartForDownload &&
                                    this.state.selectionStart != null &&
                                    this.state.selectionEnd != null && (
                                      <ReferenceArea
                                        x1={this.state.selectionStart}
                                        x2={this.state.selectionEnd}
                                        strokeOpacity={0}
                                        fill="rgba(37, 99, 235, 0.25)"
                                      />
                                    )}

                                  <RechartsTooltip
                                    content={({ active, payload }) => {
                                      if (active && payload && payload.length) {
                                        const p = payload[0].payload;
                                        const startH = Math.floor(p.time / 60);
                                        const startM = p.time % 60;
                                        const endH = Math.floor((p.time + p.duration) / 60);
                                        const endM = (p.time + p.duration) % 60;
                                        return (
                                          <div style={{ backgroundColor: "#fff", padding: "5px 10px", border: "1px solid #ccc" }}>
                                            {`CH${p.channelNo} @ ${String(startH).padStart(2, "0")}:${String(startM).padStart(2, "0")} - ${String(endH).padStart(2, "0")}:${String(endM).padStart(2, "0")}`}
                                          </div>
                                        );
                                      }
                                      return null;
                                    }}
                                  />

                                  <Scatter
                                    data={this.state.filledData}
                                    shape={(props) => {
                                      const { payload, xAxis, cy } = props;
                                      // console.log('Rendering payload:', payload);
                                      const startX = xAxis.scale(payload.time);
                                      const endX = xAxis.scale(payload.time + payload.duration);
                                      const width = endX - startX;
                                      let colorCode = "#2ecc71";
                                      if (payload.channelNo == 1) {
                                        colorCode = "#E74C3C";
                                      } else if (payload.channelNo == 2) {
                                        colorCode = "#F39C12";
                                      } else if (payload.channelNo == 3) {
                                        colorCode = "#3498DB";
                                      }
                                      const height = 10;

                                      return (
                                        <rect
                                          x={startX}
                                          y={cy - height / 2}
                                          width={width}
                                          height={height}
                                          fill={colorCode}
                                          onClick={() => this.handlePlaybackPointClick(payload)}
                                          style={{ cursor: "pointer" }}
                                        />
                                      );
                                    }}
                                    onMouseDown={(e) => {
                                      if (!e || !e.payload) return;

                                      this.setState({
                                        isSelecting: true,
                                        selectionStart: Math.round(e.time),
                                        selectionEnd: null,
                                      });

                                      // console.log('Selection Started..................');
                                    }}
                                    onMouseMove={(e) => {
                                      if (!this.state.isSelecting || !e || !e.payload) return;

                                      this.setState({
                                        selectionEnd: Math.round(e.time),
                                      });
                                      // console.log(' Selecting...................................')
                                    }}
                                    onMouseUp={(e) => {

                                      const { selectionStart, selectionEnd } = this.state;

                                      if (selectionStart != null && selectionEnd != null) {
                                        const start = Math.min(selectionStart, selectionEnd);
                                        const end = Math.max(selectionStart, selectionEnd);

                                        // console.log(
                                        //   "Selected Range:",
                                        //   this.formatTime(start),
                                        //   "-",
                                        //   this.formatTime(end)
                                        // );
                                      }

                                      this.setState({
                                        isSelecting: false,
                                        focusChartForDownload: false
                                      });

                                      const downloadStartTime = this.convertMinutesTo12Hour(selectionStart);
                                      const downloadEndTime = this.convertMinutesTo12Hour(selectionEnd);
                                      if (this.state.focusChartForDownload) {
                                        this.setState({
                                          showDownloadPopup: true,
                                          downloadChannels: this.state.selectedChannels,
                                          downloadStartTimeFormatted: downloadStartTime,
                                          downloadEndTimeFormatted: downloadEndTime,
                                          videoDownloadId: e.Id
                                        });
                                      }
                                      else if (selectionStart != null) {
                                        this.handlePlaybackPointClick(e.payload);
                                      }
                                    }}
                                    opacity={(p) => p.hidden ? 0 : 1}
                                    fillOpacity={d => d.fillOpacity}
                                  />
                                </ScatterChart>
                              </ResponsiveContainer>
                            </div>
                          }
                        </>
                      )}

                      {/* TABLE VIEW */}
                      {this.state.showHowenPlaybackTable && this.state.playbackView === "TABLE" && (

                        <> {this.state.loadingData &&
                          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                            <Spin
                              spinning={this.state.loadingData}>

                            </Spin>
                          </div>
                        }
                          {

                            <div style={{
                              flex: 1,
                              display: "flex",
                              flexDirection: "column",
                              minHeight: 0,
                              overflow: "hidden"
                            }}>
                              <div style={{
                                paddingInlineStart: "20px",
                                paddingRight: "20px",
                                flexShrink: 0,
                                height: 20,
                                marginBottom: 10
                              }}>
                                {this.context.translate("_PLAY_BACK_DATA_")}
                              </div>
                              <div style={{
                                flex: 1,
                                paddingInlineStart: "20px",
                                minHeight: 0,
                                overflow: "auto"
                              }}>
                                <Table
                                  dataSource={this.state.mdvr === "H-Protocol" ? this.videoMonitoringStore.playbackhowenData : this.videoMonitoringStore.playbackData}
                                  columns={this.columns}
                                  pagination={false}
                                  bordered
                                  size="small"

                                />
                              </div>
                            </div>
                          }
                        </>
                      )}

                      {/* DOWNLOADED VIDEO LIST */}
                      {this.state.showDownloadedVideoList && (
                        <div style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          minHeight: 0,
                          overflow: "hidden"
                        }}>
                          <div style={{
                            paddingInlineStart: "20px",
                            paddingRight: "20px",
                            flexShrink: 0,
                            marginBottom: 10
                          }}>
                            {this.context.translate("_DOWNLOADED_DATA_")}
                          </div>
                          <div style={{
                            flex: 1,
                            paddingInlineStart: "20px",
                            minHeight: 0,
                            overflow: "auto"
                          }}>
                            <Table
                              dataSource={this.videoMonitoringStore.downloadedlistData.slice()}
                              columns={this.getColumns()}
                              pagination={false}
                              bordered
                              size="small"

                            />
                          </div>
                        </div>
                      )}
                    </div>

                    {/* RIGHT COLUMN - Map */}
                    <div style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      minWidth: 0,
                      minHeight: 0,
                    }}>
                      <div style={{
                        flex: 1,
                        paddingTop: 50,
                        marginLeft: 20,
                        marginRight: 20,
                        minHeight: 0,

                      }}>
                        <div
                          dir={this.context.locale.language === "arabic" ? "ltr" : "ltr"}
                          className={
                            this.context.locale.language === "arabic"
                              ? "arabic-map-container"
                              : ""
                          }
                          style={{ height: "calc(90vh - 330px)" }}
                        >
                          <MapContainer
                            ref={this.mapRef}
                            zoom={config.mapZoom}
                            center={config.mapCenter}
                            style={{
                              height: "100%",
                              width: "100%",
                              borderRadius: '10px'
                            }}
                          >
                            {this.state.mapType === "openstreet" ? (
                              <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                              />
                            ) : (
                              <ReactLeafletGoogleLayer />
                            )}

                            <AdditionalContentInMap
                              This={this}
                              size="small"
                              showMapOptions={this.state.showMapOptions}
                              mapType={this.state.mapType}
                            />
                          </MapContainer>
                        </div>
                      </div>
                    </div>
                  </div>
                }

                {this.state.showDownloadPopup && (
                  <div
                    style={{
                      position: "fixed",
                      inset: 0,
                      background: "rgba(0,0,0,0.5)",
                      zIndex: 1000,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: 16,
                    }}
                  >
                    <div
                      style={{
                        width: 450,
                        background: "#fff",
                        borderRadius: 8,
                        padding: 24,
                        boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                      }}
                    >
                      <h3 style={{ marginBottom: 24 }}>Download Playback</h3>

                      <Form layout="vertical" ref={this.downloadformRef}>
                        {/* Channels */}
                        <Form.Item label="Select Channels">
                          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                            {[1, 2, 3, 4].map((ch) => (
                              <label
                                key={ch}
                                style={{
                                  flex: "1 1 20%",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 4,
                                  marginBottom: 8,
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={this.state.downloadChannels.includes(ch)}
                                  onChange={() =>
                                    this.setState((prev) => ({
                                      downloadChannels: prev.downloadChannels.includes(ch)
                                        ? prev.downloadChannels.filter((c) => c !== ch)
                                        : [...prev.downloadChannels, ch],
                                    }))
                                  }
                                />
                                CH{ch}
                              </label>
                            ))}
                          </div>
                          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                            {[5, 6, 7, 8].map((ch) => (
                              <label
                                key={ch}
                                style={{
                                  flex: "1 1 20%",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 4,
                                  marginBottom: 8,
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={this.state.downloadChannels.includes(ch)}
                                  onChange={() =>
                                    this.setState((prev) => ({
                                      downloadChannels: prev.downloadChannels.includes(ch)
                                        ? prev.downloadChannels.filter((c) => c !== ch)
                                        : [...prev.downloadChannels, ch],
                                    }))
                                  }
                                />
                                CH{ch}
                              </label>
                            ))}
                          </div>
                        </Form.Item>

                        {/* Start Time */}
                        <Form.Item
                          name="fromTime"
                          label="Start Time"
                          className="blur-input"
                          rules={[{ required: true }]}
                          value={this.state.downloadStartTimeFormatted}
                          initialValue={this.state.downloadStartTimeFormatted}
                        >
                          <Select
                            onChange={(val) =>
                              this.setState({ downloadStartTimeFormatted: val })
                            }
                          >
                            {downloadTimeArray.map((data) => (
                              <Select.Option key={format(data.time, "h:mm aa")} value={format(data.time, "h:mm aa")}>
                                {format(data.time, "h:mm aa")} {/* or format(data.time, "h:mm aa") */}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>

                        {/* End Time */}
                        <Form.Item
                          name="toTime"
                          label="End Time"
                          className="blur-input"
                          rules={[{ required: true }]}
                          value={this.state.downloadEndTimeFormatted}
                          initialValue={this.state.downloadEndTimeFormatted}
                        >
                          <Select
                            onChange={(val) => this.setState({ downloadEndTimeFormatted: val })}
                          >
                            {downloadTimeArray.map((data) => (
                              <Select.Option key={format(data.time, "h:mm aa")} value={format(data.time, "h:mm aa")}>
                                {format(data.time, "h:mm aa")}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>

                        {/* Buttons */}
                        <div style={{ textAlign: "right", marginTop: 16 }}>
                          <Button
                            onClick={() => this.setState({
                              showDownloadPopup: false, downloadChannels: [],
                              downloadStartTimeFormatted: null,
                              downloadEndTimeFormatted: null,
                              selectionStart: null,
                              selectionEnd: null
                            })}
                            style={{ marginRight: 8 }}
                          >
                            Cancel
                          </Button>
                          <Button type="primary" onClick={this.startDownload}>
                            Start Download
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </div>
                )}

              </Col>


            }
          </Row>

          <Drawer
            placement="right"
            className="videomonitoringdrawer"
            width={440}
            open={this.state.showPlaybackPanel}
            onClose={() => this.setState({ showPlaybackPanel: false })}
            headerStyle={{ padding: 0 }}
            closable={false}
            bodyStyle={{
              backgroundColor: "#f3f4f6",
            }}
            title={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "14px 16px",
                  borderBottom: "1px solid #e5e7eb",
                  backgroundColor: "#e0e0e0",
                }}
              >
                <span style={{ fontSize: 16, fontWeight: 600 }}>
                  {this.context.translate("_PLAY_BACK_OPTION_")}
                </span>

                <i
                  className="bi bi-x-lg"
                  style={{
                    cursor: "pointer",
                    fontSize: 18,
                  }}
                  onClick={() => this.setState({ showPlaybackPanel: false })}
                />
              </div>
            }
          >
            <Card
              bordered={false}
              style={{
                borderRadius: 8,
                padding: 16,
                marginTop: 16,
                marginLeft: 2,
                marginRight: 16,
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              }}
            >

              <Form
                ref={this.formRef}
                layout="vertical"
                name="nest-messages"
                onFinish={this.onSubmit}
                className="formClassv"
              >
                <Form.Item
                  className="uploadCompany"
                  name="vehicleId"
                  // label={this.context.translate("_VEHICLES_")}
                  label={
                    <span>
                      {this.context.translate("_VEHICLES_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    optionFilterProp="text"
                    filterOption={(input, option) =>
                      (option?.text ?? "").toLowerCase().includes(input.toLowerCase())
                    }
                    onSelect={(value) => {
                      const filteredData = this.state.treeData?.filter(
                        (item) => item.vehicleId === value
                      );
                      const MDVR = filteredData[0]?.MDVR;
                      MDVR === "H-Protocol"
                        ? this.setState({ showDownloadbtn: true })
                        : this.setState({ showDownloadbtn: false });
                      this.setState({
                        vehicleId: value,
                        selectedvehicleName: filteredData[0]?.vehicleNo,
                      });
                    }}
                    options={this.videoMonitoringStore.deviceListArray}
                    fieldNames={{ value: "vehicleId", label: "text" }}
                  />
                </Form.Item>
                {
                  /*   <Form.Item
                    className="uploadCompany"
                    name="channelId"
                    label={
                      <span>
                        {this.context.translate("_CHANNEL_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    rules={[{ required: true }]}
                    required={false}
                  >
                    <Select
                      style={{ height: "44px !important" }}
                      placeholder={this.context.translate("_SELECT_CHANNEL_")}
                      options={[
                        { label: "Channel1", value: 1 },
                        { label: "Channel2", value: 2 },
                        { label: "Channel3", value: 3 },
                        { label: "Channel4", value: 4 },
                        { label: "Channel5", value: 5 },
                        { label: "Channel6", value: 6 },
                        { label: "Channel7", value: 7 },
                        { label: "Channel8", value: 8 },
                      ]}
                      className="search-field"
                      mode="multiple"
                      maxTagCount={"responsive"}
                    />
                  </Form.Item> */
                }

                <Form.Item
                  name="fromDate"
                  className="blur-input"
                  label={this.context.translate("_FROM_DATE_")}
                  initialValue={dayjs()}
                >
                  <DatePicker
                    style={{ width: "100%", height: "40px" }}
                    format={"YYYY-MM-DD"}
                  />
                </Form.Item>

                <Form.Item
                  name="fromTime"
                  label={this.context.translate(
                    "_FLEET_RULESELECTORDETAIL_RULE4_FROMTIME_"
                  )}
                  className="blur-input"
                  rules={[{ required: true }]}
                  initialValue={"00:00:00"}
                >
                  <Select
                    onChange={(val) =>
                      this.formRef.current.setFieldsValue({ fromTime: val })
                    }
                  >
                    {timeArray.map((data) => {
                      return (
                        <Select.Option
                          key={data.formattedTime}
                          value={data.formattedTime}
                        >
                          {format(data.time, "h:mm aa")}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>

                {/* <Form.Item
                  name="toDate"
                  className="blur-input"
                  label={this.context.translate("_TO_DATE_")}
                >
                  <DatePicker
                    defaultValue={dayjs()}
                    style={{ width: "100%", height: "40px" }}
                    format={"YYYY-MM-DD"}
                  />
                </Form.Item> */}

                <Form.Item
                  name="toTime"
                  label={this.context.translate(
                    "_FLEET_RULESELECTORDETAIL_RULE4_TOTIME_"
                  )}
                  className="blur-input"
                  rules={[{ required: true }]}
                  initialValue={this.getNearestHalfHour()}
                >
                  <Select
                    onChange={(val) =>
                      this.formRef.current.setFieldsValue({ toTime: val })
                    }
                  >
                    {timeArray.map((data) => {
                      return (
                        <Select.Option
                          key={data.formattedTime}
                          value={data.formattedTime}
                        >
                          {format(data.time, "h:mm aa")}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>

                <Form.Item label=" ">
                  <Button
                    htmlType="submit"
                    type="primary"
                    style={{ width: "100%" }}
                  >
                    {this.context.translate("_FLEET_SHOW_BTN_")}
                  </Button>
                </Form.Item>
                {this.state.showDownloadbtn && <Form.Item label=" ">
                  <Button
                    // htmlType="submit"
                    type="primary"
                    style={{ width: "100%" }}
                    onClick={this.handleDownloadVideoList}
                  >
                    {this.context.translate("_DOWNLOAD_VIDEO_LIST_BUTTON_")}
                  </Button>
                </Form.Item>}
              </Form>
            </Card>
          </Drawer>

          <Modal
            open={this.state.openVideoModal}
            onCancel={this.closeModal}
            footer={null}
            width={800}
            title={this.state.selectedIframe?.title}
          >
            {this.state.selectedIframe && (
              this.state.selectedIframe.mdvr === "H-Protocol" ? (
                <HLSPlayer src={this.state.selectedIframe.src} />
              ) : this.state.selectedIframe.mdvr === "JT1078" ? (
                <FlvPlayer url={this.state.selectedIframe.src} />
              )
                :
                <iframe
                  key={this.state.selectedIframe.key}
                  src={this.state.selectedIframe.src}
                  width="100%"
                  height="200px"
                  frameBorder="0"
                  scrolling="no"
                  allow="fullscreen"
                  title={`Video Player ${this.state.selectedIframe.key}`}
                />
            )}
          </Modal>
        </div>

        <Button
          type="primary"
          shape="circle"
          icon={<i className="bi bi-play-btn-fill" />}
          size="middle"
          onClick={() =>
            this.setState((prev) => ({
              showPlaybackPanel: !prev.showPlaybackPanel,
            }))
          }
          title={this.context.translate("_PLAYBACK_PANEL_")}
          style={{
            position: "fixed",
            bottom: 25,
            right: 25,
            zIndex: 1000,
            width: 36,
            height: 36,
            backgroundColor: "rgb(0, 39, 102)",
          }}
        />

        {this.state.focusChartForDownload &&
          this.chartRef.current &&
          (() => {
            const rect = this.chartRef.current.getBoundingClientRect();

            return (
              <div
                style={{
                  position: "fixed",
                  inset: 0,
                  zIndex: 999,
                  pointerEvents: "none", // 🔑 CRITICAL
                }}
              >
                <div style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: rect.top,
                  background: "rgba(0,0,0,0.5)",
                }} />

                <div style={{
                  position: "absolute",
                  top: rect.bottom,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: "rgba(0,0,0,0.5)",
                }} />

                <div style={{
                  position: "absolute",
                  top: rect.top,
                  left: 0,
                  width: rect.left,
                  height: rect.height,
                  background: "rgba(0,0,0,0.5)",
                }} />

                <div style={{
                  position: "absolute",
                  top: rect.top,
                  right: 0,
                  width: window.innerWidth - rect.right,
                  height: rect.height,
                  background: "rgba(0,0,0,0.5)",
                }} />
              </div>
            );
          })()}


        {/* {this.state.openRecordPopup && (
          <div
            onClick={() => {
              this.closeRecordPopup(); // always closes — recording already started via signal icon click
            }}
            style={{
              position: "absolute",
              bottom: 75,
              right: 25,
              zIndex: 1000,
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              background: "#0b2e59",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
              cursor: "pointer",
            }}
          >
            <AudioOutlined style={{ fontSize: "17px", color: "#fff" }} />
            <audio ref={this.audioRef} style={{ display: 'none' }} />
          </div>
        )} */}
        <audio ref={this.audioRef} style={{ display: 'none' }} />

        {this.state.openRecordPopup && (
          <div
            onClick={() => this.closeRecordPopup()}
            style={{
              position: "absolute",
              bottom: 75,
              right: 25,
              zIndex: 1000,
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              background: "#0b2e59",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
              cursor: "pointer",
            }}
          >

            {this.state.isRecording ? (
              <AudioOutlined style={{ fontSize: "17px", color: "#fff" }} />
            ) : (
              <LoadingOutlined style={{ fontSize: "17px", color: "#fff" }} />
            )}
          </div>
        )}

      </div >

    );
  }
}
VideoMonitoring.contextType = StoreContext;
export default observer(withRouter(VideoMonitoring));
